import { Component } from '@angular/core';
import { IonicPage, LoadingController, NavController, NavParams } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';

/**
 * Generated class for the ModalsEngineselectorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-modals-engineselector',
  templateUrl: 'modals-engineselector.html',
})
export class ModalsEngineselectorPage {
  private loading;
  public engineList = [];

  activeengine: number;
  status: boolean = false;
  prevEngine = localStorage.getItem('engine') == null ? 'Autodesk.Revit+2020' : localStorage.getItem('engine');
  enginename = '';

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public loadingController: LoadingController,
    private rest: RestProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalsEngineselectorPage');
    this.presentLoadingWithOptions();
    this.rest.dumpEngines().subscribe(engines => {
      engines.data.forEach(element => {
        if(element.split('.')[1].substring(0,5) == 'Revit') {
          this.engineList.push(element);
        }
      });
      this.engineList.sort();
      this.stopLoading();
    });
  }

  engineSelect(engine, id) {
    $('.activeli').removeClass('activeli');
    $('#liElement' + id).children('li').addClass('activeli');
    this.status = !this.status;
    this.enginename = engine;
    localStorage.setItem('engine', this.enginename);
    let engineSplit = engine.split('.');
  }
  dismiss() {
    this.navCtrl.pop();
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    console.log('loader ---->>>>');
    return await this.loading.present();
  }
  
  async stopLoading() {
    console.log('loader <<<<----');
    return await this.loading.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modals-engineselector/modals-engineselector.ts